export { defaultProps, TextArea } from './TextArea'
